/**
 * Vercel Web Analytics through the generic entry.
 *
 * `@vercel/analytics/sveltekit` subscribes to `$app/stores`, which throws in
 * SvelteKit 3 (hub report 2026-10-22-sveltekit-deepdive E.md A1). These two
 * functions reproduce what that entry did: inject the script with automatic
 * tracking off, then report one pageview per navigation with the route id, so
 * the Vercel dashboard keeps grouping /products/[handle] as one route.
 * Ported from FLOSSR #87 (hub ledger 2026-10-23-119).
 */
import { inject, pageview } from "@vercel/analytics";

export function injectVercelAnalytics() {
  inject({
    basePath: import.meta.env.VITE_VERCEL_OBSERVABILITY_BASEPATH,
    disableAutoTrack: true,
    framework: "sveltekit",
  });
}

/**
 * Call with `page` from `$app/state`, not afterNavigate's `to`: on the initial
 * hydration Kit 2.70 gives `to` a null route id, which would drop every landing.
 * @param {{ route: { id: string | null }, url: URL } | null} current
 */
export function trackVercelPageview(current) {
  if (!current?.route?.id) return;
  pageview({ route: current.route.id, path: current.url.pathname });
}
